import $ from 'jquery';

function FixNavigation(element) {
  this.element = element;
  this.process();
}

FixNavigation.prototype = {
  process() {
    $('.menuparent, .expanded, .collapsed', this.element).each((i, item) => {
      // handles the parent term (if hidden)
      const $parent = $(item).children('a');
      if (!$parent.length || $parent.is('.hidden')) {
        $(item).remove();
      }

      // handles the term to see if it only parents orphans.
      const $children = $('> ul > li', item);
      if (!$parent.is('.hidden') && $children.length) {
        const $orphans = $children.children('a.hidden');
        $orphans.parent().remove();
        if ($orphans.length === $children.length) {
          $(item).removeClass('expanded menuparent collapsed');
          $(item).children('ul').remove();
        }
      }
    });
  },
};

export default FixNavigation;



// WEBPACK FOOTER //
// ./FixNavigation.js